export const HOTEL_ID = "hotel-search";
export const HOTEL_DURATION_EXPIRED = 60 * 1000 * 15;

export const HOTEL_CURRENCY = "BDT";
export const HOTEL_NATIONALITY = "BD";
